import createReactComponent from '../createReactComponent';
export default createReactComponent('minus-circle', 'MinusCircle', [["path",{"d":"M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M8.5 12h7","key":"svg-0"}]]);